<div class="page">
  <div class="center-column">
    <!-- ================= STEP 1 : SELECTION ================= -->
    <div class="card selection-card" *ngIf="step === 'selection'">
      <h1>Data Bridge</h1>
      <p class="subtitle">Do you currently have a Data Bridge?</p>

      <div
        class="option"
        [class.selected]="hasDataBridge === true"
        (click)="hasDataBridge = true"
      >
        <div class="option-icon">
          <img src="assets/login/databridge_icon.svg" alt="Data Bridge" [class.blue-tint]="hasDataBridge === true" />
        </div>
        <div class="option-content">
          <div class="option-title">Yes, I own a Data Bridge</div>
          <div class="option-subtitle">Add Data Bridge details in the next step</div>
        </div>
      </div>

      <div
        class="option"
        [class.selected]="hasDataBridge === false"
        (click)="hasDataBridge = false"
      >
        <div class="option-icon">
          <img src="assets/login/databridge_icon.svg" alt="No Data Bridge" />
        </div>
        <div class="option-content">
          <div class="option-title">No, I don’t own a Data Bridge</div>
          <div class="option-subtitle">You can add a Data Bridge anytime from Profile</div>
        </div>
      </div>

      <lib-button
        class="continue-btn"
        variant="contained"
        size="medium"
        type="primary"
        [isDisabled]="hasDataBridge === null"
        label="Continue"
        (click)="continue()"
      ></lib-button>
    </div>

    <!-- ================= STEP 2 : CONNECTION ================= -->
    <div class="card connection-card" *ngIf="step === 'connection'">
      <h1>Connect data bridge</h1>
      <p class="subtitle">
        Set up your data bridge to sync real-time information — or skip and add it anytime.
      </p>

      <div class="device-list-header">Available Devices</div>

      <div class="device-list">
        <div
          class="device-item"
          *ngFor="let device of availableDevices"
          [class.selected]="selectedDeviceId === device.id"
          (click)="selectDevice(device.id)"
        >
          <div class="device-info">
            <div class="device-icon">
               <img [src]="device.icon" alt="Device" [class.blue-tint]="selectedDeviceId === device.id" />
            </div>
            <div class="device-name">{{ device.name }}</div>
          </div>
          <div class="device-select-icon" *ngIf="selectedDeviceId === device.id">
            <mat-icon>check</mat-icon>
          </div>
        </div>
      </div>
    </div>

    <!-- ================= FOOTER (STEP 2 ONLY) ================= -->
    <div class="footer" *ngIf="step === 'connection'">
      <lib-button
        variant="contained"
        size="medium"
        type="secondary"
        label="Back"
        (click)="goBack()"
      ></lib-button>

      <lib-button
        variant="contained"
        size="medium"
        type="primary"
        label="Next"
        (click)="next()"
      ></lib-button>
    </div>
  </div>
</div>
